import React from 'react'
import {Badge, Media} from 'reactstrap'
import TankFillMobileImg from '../../images/tank-fill.png'
import TankFillImg from '../../images/tank-fill-light.png'
import TankFillRedImg from '../../images/tank-fill-red.png'
import TankCoverImg from '../../images/tank-cover-light.png'
import TankMaskImg from '../../images/tank-mask-1.png'
import TankShadowImg from '../../images/tank-shadow.png'
import {pageHelpers} from '../pages'
import '../../stylesheets/TankGauge.css'

let calculateTankLevelOffset = (tankLevel, tankSize, height) => {
    let offset = 0
    if (tankSize && tankSize > 0) {
        offset = (tankLevel / tankSize)
    } else {
        offset = (tankLevel > 0 ? (tankLevel > 0.2 ? 0.7 : 0.3) : 0)
    }

    offset = (0.65 * height) * (1.0 - offset)
    return offset
}

class TankGauge extends React.Component {
    constructor(props) {
        super(props)
        const {tankLevel, tankLevelUnits, tankSize, lowTank, width, height} = props
        this.state = {
            tankLevel: tankLevel || 0,
            tankLevelUnits,
            tankSize,
            width: width || 160,
            height: height || 160,
            lowTank,
            offset: calculateTankLevelOffset(tankLevel, tankSize, width),
        }

        this.updateSize = this.updateSize.bind(this)
        this.setupTankFillMask = this.setupTankFillMask.bind(this)
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateSize)
        window.addEventListener("orientationchange", this.updateSize)
        this.updateSize()
        this.setupTankFillMask()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSize)
        window.removeEventListener("orientationchange", this.updateSize)
    }

    updateSize(e) {
        let {tankLevel, tankSize} = this.state
        let tankElem = document.getElementById('tank-gauge-container')
        if (tankElem && tankSize) {
            let width = tankElem.offsetWidth
            let offset = calculateTankLevelOffset(tankLevel, tankSize, width)
            this.setState({offset})
        } else {
            let {width} = this.state
            let offset = calculateTankLevelOffset(tankLevel, tankSize, width)
            this.setState({offset})
        }
    }

    componentWillReceiveProps(nextProps) {
        const {tankLevel, tankLevelUnits, tankSize, width, height, lowTank} = nextProps
        this.setState({
            tankLevel: tankLevel || 0,
            tankLevelUnits,
            tankSize,
            lowTank,
            width: width || 160,
            height: height || 160,
            offset: calculateTankLevelOffset(tankLevel, tankSize, width),
        })
        this.updateSize()
        this.setupTankFillMask()
    }

    setupTankFillMask() {
        let imagecanvas = document.createElement('canvas')
        let imagecontext = imagecanvas.getContext('2d')

        let {tankLevel, tankSize} = this.state
        let offset = 0
        if (tankSize && tankSize > 0 && tankLevel < tankSize) {
            offset = ((tankLevel / tankSize) * 0.65) + 0.24
        } else if (tankSize && tankSize > 0) {
            offset = 0.9
        } else {
            offset = (tankLevel > 0 ? (tankLevel > 0.2 ? 0.9 : 0.1) : 0)
        }
        let containerHeight = this.state.height

        let img = document.getElementById("tank-fill")
        let newImg = document.createElement('img')
        newImg.src = img.src
        newImg.onload = function () {
            let width = newImg.width
            let height = newImg.height
            let mask = document.createElement('img')
            mask.src = TankMaskImg
            mask.onload = function () {
                imagecanvas.width = width
                imagecanvas.height = height

                imagecontext.drawImage(mask, 0, -height*(1-offset), width, height)
                imagecontext.globalCompositeOperation = 'source-in'
                imagecontext.drawImage(img, 0, 0)

                img.src = imagecanvas.toDataURL()
                img.style.top = `${(containerHeight * (1.095-offset))}px`
            }
        }
    }

    render() {
        let {tankLevel, tankSize, tankLevelUnits, lowTank, width, height, offset} = this.state
        let userOnMobile = pageHelpers.userOnMobileDevice()
        return <div id="tank-gauge-container" className="tank-gauge" style={{width, height}}>
            <p className="font-weight-bold d-block text-primary">Tank Level</p>
            <Media object className="tank-shadow" src={TankShadowImg} style={{width, height}}/>
            <Media object className="tank-cover" src={TankCoverImg} style={{width, height}}/>

            <Media object className="mask tank-fill" id="tank-fill" src={lowTank ? TankFillRedImg : (userOnMobile ? TankFillMobileImg : TankFillImg)} style={{width, height}} />
            <Badge className="tank-value-badge" style={{top:-0.4*height}}>
                {tankLevel > 0 ?
                    <h3 className="font-weight-bold p-0 m-0">{tankLevel} {tankLevelUnits}</h3>:
                    <h3 className="font-weight-bold p-0 m-0">Empty</h3>
                }
            </Badge>
        </div>
    }
}

export default TankGauge



// WEBPACK FOOTER //
// ./src/components/ui/TankGauge.js